export default {
  categories: {
  shoes: 'Sko',
  hoodies: 'Hoodies/Sweatere',
  tshirts: 'T-shirts',
  jackets: 'Jakker',
  pants: 'Bukser/Shorts',
  headwear: 'Hovedbeklædning',
  sets: 'Sæt',
  underwear: 'Undertøj/Underbukser',
  jersey: 'Trøjer (jersey)',
  accessories: 'Tilbehør',
  bags: 'Tasker',
  belts: 'Bælter',
  perfumes: 'Parfumer',
  other: 'Andet',
  },
};